module.exports = __webpack_public_path__ + "img/Mastercad-securecode.1af09746.png";